// extracted by mini-css-extract-plugin
export default {"container":"container___jMMMt","title":"title___plud5","description":"description___lxWvR","time":"time___pJBbj"};